import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import "../css/Pop-up.css"

const MatchDialog = ({ open, onClose, buyer, matches, highlightMatch }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle className='titulo'>Detalles del comprador y coincidencias:</DialogTitle>
      {buyer && (
        <DialogContent>
          <div className="buyer-info-container">
            <Typography variant="h6" className="subtitulo">Información del comprador:</Typography>
            <p><strong>Nombre:</strong> {buyer.nombre} / <strong>ID:</strong> {buyer.id}</p>
            <p><strong>Correo:</strong> {buyer.correo}</p>
            <p><strong>Presupuesto:</strong> {buyer.presupuesto ? `$${buyer.presupuesto}` : "No especificado"}</p>
            <p><strong>Descripción del auto:</strong> {buyer.descripcionAuto}</p>
          </div>

          <Typography variant="h6" style={{ marginTop: '20px' }} className='subtitulo'>Coincidencias con vendedores:</Typography>
          <div className="popup-grid">
            {matches.map((seller) => (
              <div key={seller.id} className="popup-container">
              <p><span>ID:</span> {seller.id}</p>
              <p><span style={highlightMatch(seller.marca, buyer.descripcionAuto) ? { backgroundColor: "yellow" } : null}>Marca: {seller.marca}</span></p>
              <p><span style={highlightMatch(seller.modelo, buyer.descripcionAuto) ? { backgroundColor: "yellow" } : null}>Modelo: {seller.modelo}</span></p>
              <p><span style={highlightMatch(String(seller.anio), buyer.descripcionAuto) ? { backgroundColor: "yellow" } : null}>Año: {seller.anio}</span></p>
              <p><span style={highlightMatch(seller.version, buyer.descripcionAuto) ? { backgroundColor: "yellow" } : null}>Versión: {seller.version}</span></p>
            </div>
            ))}
          </div>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose} color="primary" variant='contained'>
          Cerrar
        </Button>
        {/* <Button onClick={()=>{console.log(matches);console.log(buyer);}} color="primary">
          Texto
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default MatchDialog;
